import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {KeyRound} from 'lucide-react';
import {useTheme} from 'styled-components';
import {PATHS} from 'routes/constants';
import {usePath} from 'hooks';
import {StyledNavigationItem} from './styled';
import {useKioskoStore} from 'context/kiosko';

function RemoteAccessNavigationItem() {
  const {hasTemplate} = useTheme();
  const {getFullPath} = usePath();
  const {t} = useTranslation();
  const isKiosko = useKioskoStore(state => state.connection.isConnected);

  const getRedirectPath = useCallback(() => {
    if (isKiosko) {
      return getFullPath(PATHS.remoteKeys);
    } else {
      return getFullPath(PATHS.remoteAccess);
    }
  }, [isKiosko, getFullPath]);

  return (
    <StyledNavigationItem
      maxWidth="100%"
      title={t('virtual_keys')}
      path={getRedirectPath()}
      icon={
        <KeyRound
          size={20}
          color={hasTemplate ? 'var(--brand-icons)' : 'var(--font-secondary)'}
          className="kiosko:w-12 kiosko:h-12"
        />
      }
      isStatusBoxVisible={false}
      description={t('direct_access_you_virtual_keys')}
    />
  );
}

export {RemoteAccessNavigationItem};
